<template>
    <div>
        <h2 style="margin-top:20px">Technical Specification</h2>
        <el-tabs v-model="activeTab" type="border-card">
            <el-tab-pane label="Display & Delivery" name="delivery">
                <JobFormSpecsDelivery
                        @input="updateFormValues"
                        @error="error"
                        @updateOwnerOperators="updateOwnerOperators"
                        @updateLeasePurchase="updateLeasePurchase"
                        v-model="formValues.delivery"
                        :job-id="jobId"
                        :employer-id="employerId"/>
            </el-tab-pane>
            <el-tab-pane name="pricing">
                <span slot="label">Pricing<span v-if="isPricingEmpty" class="label label-warning" style="position:relative;top:-3px;left:5px;">no prices</span></span>
                <el-row>
                    <el-col :span="24" style="padding:10px">
                        <JobFormSpecsPricing @input="updateFormValues"
                                             @error="error"
                                             v-model="formValues.pricing"
                                             :job-id="jobId"
                                             :is-empty.sync="isPricingEmpty"
                                             :employer-id="employerId"
                                             :cdl-xp="`` + cdlXp"
                                             :is-owner-operators-job="isOwnerOperators"
                                             :is-lease-purchase-job="isLeasePurchase"/>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane name="snippets">
                <span slot="label">Snippets</span>
                <el-row>
                    <el-col :span="24" style="padding:10px">
                        <JobFormSpecsSnippets @input="updateFormValues"
                                             v-model="formValues.snippets"
                                             :job_id="jobId"
                                             :job_data="formValues.delivery.filters ? formValues.delivery.filters : []"
                                             :employer_id="employerId"/>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import JobFormSpecsDelivery from './specs/job-form-specs-delivery.vue';
import JobFormSpecsPricing from './specs/job-form-specs-pricing.vue';
import JobFormSpecsSnippets from './../../../Snippet/vue/job-form-snippets.vue';

export default {
        components: { JobFormSpecsDelivery, JobFormSpecsPricing, JobFormSpecsSnippets },
        props: {
            jobId: { type: Number, required: true },
            employerId: { type: Number, required: true },
            value: { type: Object, required: true },
        },
        data() {
            return {
                activeTab: 'delivery',
                formValues: {
                    pricing: typeof this.value.pricing === 'undefined' ? {} : this.value.pricing,
                    delivery: typeof this.value.delivery === 'undefined' ? {} : this.value.delivery,
                    snippets: typeof this.value.snippets === 'undefined' ? { jobInfo: {}, employerInfo: {} } : this.value.snippets,
                },
                isOwnerOperators: false,
                isLeasePurchase: false,
                cdlXp: '',
                isPricingEmpty: true,
            };
        },
        methods: {
            updateFormValues() {
                this.$emit('input', this.formValues);
                if (typeof this.formValues.delivery['info'] !== 'undefined') {
                    this.cdlXp = this.formValues.delivery.info.cdlMinXp;
                }
            },
            error(message) { this.$emit('error', message); },
            updateOwnerOperators(value) { this.isOwnerOperators = value; },
            updateLeasePurchase(value) { this.isLeasePurchase = value; },
        },
    };
</script>